module.exports = "<div button text=\"Шоссе\" classes=\"filter__highway-browser-trigger filter__popup-trigger\" \n     is-popup-open=\"highwayBrowser.isPopupOpen\"\n     button-style=\"{$ highwayBrowser.isPopupOpen?'solid':'bright' $}\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/highway-browser/templates/highway-browser.html
// module id = 369
// module chunks = 0